import { A11yModule } from '@angular/cdk/a11y';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormCommonModule } from '@x/common/form';
import { OperationModule } from '@x/common/operation';
import { AddressCloseConfirmationDialogComponent } from '@x/ecommerce-shop/app/core/address/components/address-close-confirmation-dialog/address-close-confirmation-dialog.component';
import { AddressFormBottomSheetComponent } from '@x/ecommerce-shop/app/core/address/components/address-form-bottom-sheet/address-form-bottom-sheet.component';
import { AddressMapComponent } from '@x/ecommerce-shop/app/core/address/components/address-map/address-map.component';
import { AddressPipe } from '@x/ecommerce-shop/app/core/address/pipes/address.pipe';
import { AddressService } from '@x/ecommerce-shop/app/core/address/services/address.service';
import { ShopErrorModule } from '@x/ecommerce-shop/app/core/shop-error/shop-error.module';
import { BannerButtonModule } from '@x/ecommerce-shop/app/core/shop-ui/components/banner-button/banner-button.module';
import { CloseButtonModule } from '@x/ecommerce-shop/app/core/shop-ui/components/close-button/close-button.module';
import { IconUiModule } from '@x/ecommerce-shop/app/core/shop-ui/components/icon-ui/icon-ui.module';
import { BottomSheetLayoutModule } from '@x/ecommerce-shop/app/core/shop-ui/components/layout/bottom-sheet-layout/bottom-sheet-layout.module';
import { FormLayoutModule } from '@x/ecommerce-shop/app/core/shop-ui/components/layout/form-layout/form-layout.module';
import { HeaderLayoutModule } from '@x/ecommerce-shop/app/core/shop-ui/components/layout/header-layout/header-layout.module';
import { PageLayoutModule } from '@x/ecommerce-shop/app/core/shop-ui/components/layout/page-layout';
import { ShopDialogUiModule } from '@x/ecommerce-shop/app/core/shop-ui/components/shop-dialog-ui/shop-dialog-ui.module';
import { UtilsModule } from '@x/ecommerce-shop/app/core/utils/utils.module';
import { InputLoaderModule } from 'apps/ecommerce-shop/src/app/core/shop-ui/components/input-loader';
import { LoaderModule } from 'libs/common/src/loader';
import { AddressBookComponent } from './components/address-book/address-book.component';
import { AddressRegionNoMatchDialogComponent } from './components/address-region-no-match-dialog/address-region-no-match-dialog.component';
import { AddressViewDialogComponent } from './components/address-view-dialog/address-view-dialog.component';
import { AddressFormLabelPipe } from './pipes/address-form-label.pipe';

@NgModule({
  providers: [MatBottomSheet, AddressService],
  declarations: [
    AddressFormBottomSheetComponent,
    AddressPipe,
    AddressBookComponent,
    AddressRegionNoMatchDialogComponent,
    AddressMapComponent,
    AddressViewDialogComponent,
    AddressFormLabelPipe,
    AddressCloseConfirmationDialogComponent,
  ],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    BottomSheetLayoutModule,
    MatButtonModule,
    FormLayoutModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    FormCommonModule,
    LoaderModule,
    BannerButtonModule,
    MatTooltipModule,
    InputLoaderModule,
    FontAwesomeModule,
    IconUiModule,
    ShopDialogUiModule,
    GoogleMapsModule,
    UtilsModule,
    MatChipsModule,
    HeaderLayoutModule,
    PageLayoutModule,
    A11yModule,
    OperationModule,
    MatStepperModule,
    CdkStepperModule,
    CloseButtonModule,
    ShopErrorModule,
  ],
  exports: [
    AddressFormBottomSheetComponent,
    AddressPipe,
    AddressBookComponent,
    AddressMapComponent,
  ],
})
export class AddressModule {}
